<app-ver-detalle-propuesta>
  <span class="app">
    <div class="row">
      <div class="col-12 col-sm-3 text-start">
        <h4>INFORMACIÓN DE LA SOLICITUD</h4>
      </div>
      <div class="col-12 col-sm-3 text-right">
        <span style="font-size: 45px"><i class="far fa-check-circle"></i></span>
      </div>
      <div class="col-12 col-sm-6 text-start">
        <h4>¿SEGURO QUE DESEAS APROBAR LA OFERTA PARA ESTE CLIENTE?</h4>
      </div>
    </div>
  </span>

  <div class="container">
    <form [formGroup]="aprobarForm">
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xs-12 mt-4">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('observacionAprobar')}">
            <label for="observacionAprobar">Incluye aquí las observaciones que quieres dar a conocer al microempresario. Recuerda que esta información la visualizará el microempresario al momento de revisar tu oferta de crédito*</label>
            <textarea class="form-control" style="width: 100%;" name="observacionAprobar" formControlName="observacionAprobar"
              rows="4" maxlength="1501" [ngClass]="{ 'is-invalid': validateField('observacionAprobar')}"
            (keyup)="validarLongitud()" required></textarea>
            <span>El número de caracteres máximos permitidos es de 1500, caracteres ingresados: {{auxCaracteres}}</span>
            <div class="invalid-feedback" style="color: #dc3545 !important; font-size: 1.10rem;">
              @if (aprobarForm.get('observacionAprobar').errors?.required) {
                <span>
                  El campo es obligatorio.
                </span>
              }
              @if (aprobarForm.get('observacionAprobar').errors?.maxlength) {
                <span>
                  No puede exceder los 1500 caracteres permitidos.
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row justify-content-md-center mt-4 g-3">
      <div class="col-12 col-sm-2 container-btn">
        <button class="btn btn-primary" (click)="aprobar()">Aprobar</button>
      </div>
      <div class="col-12 col-sm-2 container-btn">
        <button class="btn btn-primary" (click)="cancelar()">Volver</button>
      </div>
    </div>
  </div>
</app-ver-detalle-propuesta>

<!-- Modal -->
<div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body-monto justify-content-md-center">
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <h3>La oferta ha sido aprobada correctamente</h3>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
